import React from 'react';
import './ToolSlide.css';
import { directDeepLink, SOURCE_HOME,SOURCE_WEBVIEW } from '../../../util';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {
	create_and_share_poster,
	Tips_from_experts,
	create_polls,
	send_notification
} from '../../../../../cosmosTracking/cosmosEvents';
import holippl from '../../../../../assets/images/holi-people.png';
import { resolveTutorHomeAsset } from '../tutorHomeConfig';
function ToolSlide(props) {
	const { data, config = {} } = props;
	const handleClick = (tool,index) => {
		if (index === 0) {
			cosmosTrackService(create_and_share_poster);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 1) {
			cosmosTrackService(create_polls);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 2) {
			cosmosTrackService(Tips_from_experts);
			directDeepLink(tool?.deeplink, SOURCE_HOME,SOURCE_WEBVIEW );
		} else if (index === 3) {
			cosmosTrackService(send_notification);
			directDeepLink(tool?.deeplink, SOURCE_HOME ,SOURCE_WEBVIEW );
		}
	}
	return (
		<div className="slideCard slideCardTools">
			<div className="cardBody" style={config.images?.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(config.images.card_background)}")`} : undefined}>
			{/* <img src={holippl} className='overlay-image' /> */}

			<div className="body-card-inner">
			 <img className="tool-top-img" src={resolveTutorHomeAsset(config.images?.header_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/2c21a99d-4f9e-44cb-b9b3-9dd11f70ecce.jpeg')}  alt="tool img"/>
			</div>
				
				<div className="toolGroup">
					{data.slice(0, 4)?.map((tool, index) => (
						<div className="toolBtn" onClick={() => handleClick(tool, index)} key={index}>
							{index === 0 && <img
								src={resolveTutorHomeAsset(config.images?.tool_icons?.[0] || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-create.png')}
								width={20}/>}
							{index === 1 && <img
								src={resolveTutorHomeAsset(config.images?.tool_icons?.[1] || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-video.png')}
								width={20}/>}
							{index === 2 && <img
								src={resolveTutorHomeAsset(config.images?.tool_icons?.[2] || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-user.png')}
								width={20}/>}
							{index === 3 && <img
								src={resolveTutorHomeAsset(config.images?.tool_icons?.[3] || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-book.png')}
								width={20}/>}
							{tool?.text}
							<img
								src={resolveTutorHomeAsset(config.images?.next_icon || 'https://cdn-wl-assets.classplus.co/production/379965/26a1a59e-0165-4482-89ff-f55db57e98c8.png')}
								width={20}/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default ToolSlide;
